import { Utils } from './../../../utils/Utils';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { CryptoConfirmDialogComponent } from '../../../../../modules/shared/components/dialogs/crypto-confirm-dialog/crypto-confirm-dialog.component';
import { ORDER_ERRORS } from 'src/app/pages/core/models/Order';
import { ErrorHandlingService } from 'src/app/pages/core/services/utils/error-handling.service';
import { ConfirmDialogComponent } from 'src/app/modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let fbq: Function;

@Component({
  selector: 'app-confirm-bundle-order',
  templateUrl: './confirm-bundle-order.component.html',
  styleUrls: ['./confirm-bundle-order.component.scss'],
})
export class ConfirmBundleOrderComponent implements OnInit, OnDestroy {
  countDownSecond = 10;
  showCountDownSecond: boolean;
  firstLockBundleDone = false;
  isProcessing = false;
  codeTimeout = false;
  errorText = '';
  showError = false;
  priceIntervalRef;

  constructor(
    public dialogRef: MatDialogRef<ConfirmBundleOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public cryptoService: CryptoService,
    public errorHandler: ErrorHandlingService,
    public confirmDialog: MatDialog,
    public router: Router,
    public authService: AuthService,
    private readonly sso: ScrollStrategyOptions,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (this.data.lockedBundle.expires) {
      const startTime = new Date().getTime();
      this.setPriceTimer(startTime);
      this.firstLockBundleDone = true;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.priceIntervalRef);
  }

  getCoinQuantity(ticker: string) {
    const coinPercentage =
      this.data.coins.find((coin) => coin.ticker === ticker.split('_')[0])?.percentage || 0;
    return (this.data.fiatAmount * coinPercentage) / this.data.lockedBundle.locks[ticker].price;
  }

  setPriceTimer(startTime: number) {
    this.showCountDownSecond = true;
    this.priceIntervalRef = setInterval(() => {
      const currentTime = new Date().getTime();
      const distance = currentTime - startTime;
      this.countDownSecond = 10 - Math.floor((distance % (1000 * 10)) / 1000);
      if (distance >= 10000) {
        clearInterval(this.priceIntervalRef);
        this.showCountDownSecond = false;
        this.codeTimeout = true;
        this.data.options[0] = 'Refrescar';
      }
    }, 1000);
  }

  relockPrice() {
    this.isProcessing = true;
    this.cryptoService.lockBundleOrder(this.data.coinsTickers, this.data.operation).subscribe(
      (res) => {
        if (res) {
          this.data.lockedBundle = res;
          if (this.data.isMaxOperation) {
            if (this.data.operation === 'BUY') {
              this.data.fiatAmount = Utils.roundDown(
                this.authService.loggedUser.balance.fiat[this.data.currency],
              );
            } else {
              this.getTotalLockedBundleAmount(this.data.ticker, this.data.currency);
            }
          }
          this.codeTimeout = false;
          this.data.options[0] = 'Aceptar';
          const startTime = new Date().getTime();
          this.setPriceTimer(startTime);
          this.data.prices = this.data.coinsTickers.reduce(
            (obj, coin) => ((obj[coin] = this.data.lockedBundle.locks[coin].price), obj),
            {},
          );
          this.isProcessing = false;
        }
      },
      (err) => {
        this.isProcessing = false;
        this.errorText = 'Error en obtener nuevo precio, intentá nuevamente.';
        this.showError = true;
      },
    );
  }

  getTotalLockedBundleAmount(ticker: string, currency: string) {
    const bundle = this.authService.loggedUser.balance?.bundle.ARS[ticker];
    let total = 0;
    Object.keys(bundle).forEach((coin) => {
      total += +bundle[coin]?.amount * +this.data.lockedBundle.locks[coin + '_' + currency]?.price;
    });
    return total;
  }

  getValueByTicker(ticker, percentage) {
    const prices = this.data.coinsTickers.reduce(
      (obj, coin) => ((obj[coin] = this.data.lockedBundle.locks[coin].price), obj),
      {},
    );
    const price = prices[ticker + '_' + this.data.currency][this.data.operation];
    return (this.data.fiatAmount * percentage) / price;
  }

  handleOrder() {
    this.isProcessing = true;
    if (this.data.isMaxOperation) {
      if (this.data.operation === 'BUY') {
        this.data.fiatAmount = Utils.roundDown(
          this.authService.loggedUser.balance.fiat[this.data.currency],
        );
      } else {
        this.data.fiatAmount = this.getTotalLockedBundleAmount(
          this.data.ticker,
          this.data.currency,
        );
      }
    }
    this.cryptoService
      .createBundleOrder(
        this.data.ticker + '_' + this.data.currency,
        this.data.fiatAmount,
        this.data.operation,
        this.data.lockedBundle,
      )
      .subscribe(
        (res) => {
          clearInterval(this.priceIntervalRef);
          this.isProcessing = false;
          const origAmount = res.order.amount * res.order.price;
          this.confirmDialog.open(CryptoConfirmDialogComponent, {
            data: {
              isBundle: true,
              ticker: this.data.ticker,
              origAmount,
              operation: this.data.operation === 'BUY' ? 0 : 1,
              currency: this.data.currency,
              coinsAmounts: this.data.coinsAmounts,
            },
            panelClass: 'deposit',
            maxWidth: '90vw',
            scrollStrategy: this.sso.reposition({
              autoClose: false,
              scrollThrottle: 300,
            }),
          });

          this.dialogRef.close(true);

          // Facebook pixel tracking
          fbq(
            'track',
            this.data.operation === 'BUY'
              ? `Compra de ${this.data.ticker}`
              : `Venta de ${this.data.ticker}`,
            {
              currency: this.data.ticker,
              value: this.data.fiatAmount,
            },
          );

          // Google Analytics tracking
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              marketTx: true,
              coin: this.data.ticker,
              operation: this.data.operation,
            },
          });
        },
        (error) => {
          this.isProcessing = false;
          clearInterval(this.priceIntervalRef);
          this.showCountDownSecond = false;
          this.codeTimeout = true;
          this.data.options[0] = 'Refrescar';
          const errorMessages = this.errorHandler.handleError(error);
          const ref = this.confirmDialog.open<AlertDialogComponent, AlertDialogData>(
            AlertDialogComponent,
            {
              panelClass: 'modal-container',
              data: {
                title: errorMessages.title,
                content: errorMessages.body,
                errorCode: errorMessages.errorCode,
                isError: true,
              },
            },
          );
          ref.afterClosed().subscribe((data) => {
            if (data) {
              if (error.error.internalStatus === ORDER_ERRORS.BLOCKED_UIF) {
                this.dialogRef.close();
                this.router.navigate(['profile', 'documentation'], {
                  state: { toDocumentation: true },
                });
              }
            }
          });
        },
      );
  }

  closeDialog(operated: boolean) {
    this.dialogRef.close(operated);
  }
}
